export var props = {
  hovering: {
    type: Boolean,
    default: true
  }
};